<div class="flex">
  <sbnb-subnav [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'statements-transaction-list'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main class="flex flex-1 subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div class="w-full relative">
      <app-feature-flag-tabs class="w-full">
        <ng-container navTabs>
          <sbnb-page-header [parentPath]="'menu-mobile/ops-mobile'" class="absolute top-0 left-0"></sbnb-page-header>
          <div class="flex justify-center items-center flex-col sbnbDesktop:flex-row sbnbDesktop:justify-start gap-2">
            <h2 class="flex-1">Transactions</h2>
            <sbnb-button routerLink="add" size="mini" label="+ Add Transaction"></sbnb-button>
          </div>
        </ng-container>
        <div class="flex">
          <h2 class="flex-1">Transactions</h2>
          <sbnb-button routerLink="add" size="mini" label="+ Add Transaction"></sbnb-button>
        </div>
      </app-feature-flag-tabs>

      <div>
        <mat-tab-group>
          <mat-tab label="Transactions">
            <ng-container *ngTemplateOutlet="transactionsTab"></ng-container>
          </mat-tab>
          <mat-tab label="Scheduled">
            <sbnb-statements-transactions-scheduled></sbnb-statements-transactions-scheduled>
          </mat-tab>
        </mat-tab-group>
      </div>

      <ng-template #transactionsTab>
        <div *ngIf="state$ | async as state">
          <div *ngIf="state.data?.length && !state.loading && !state.error" class="overflow-x-auto w-full">
            <table mat-table multiTemplateDataRows [dataSource]="paginatedData$ | async">
              <!-- Date Column -->
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let element" [ngClass]="{ '!border-b-0 !h-10': element.lines.length > 1 }">
                  <div class="flex gap-1 items-center">
                    <span class="whitespace-nowrap">{{ element.date | date: 'longDate' }}</span>
                    <span *ngIf="element.recurring_transaction_id" class="pr-2">
                      <sbnb-icon
                        [size]="14"
                        icon="recurring-financial"
                        [satPopoverAnchor]="p"
                        (backdropClicked)="p.close()"
                        (click)="$event.stopPropagation(); p.toggle()"
                        class="text-night-lighter hover:text-raspberry-darker"
                        [ngClass]="{ 'text-raspberry-darker': p.isOpen() }"></sbnb-icon>
                    </span>
                  </div>

                  <sat-popover verticalAlign="below" horizontalAlign="center" hasBackdrop #p>
                    <div class="popover">
                      <p>
                        This transaction was created by a
                        <a
                          class="link"
                          [routerLink]="[
                            '/operations/statements/transactions/',
                            element.recurring_transaction_id,
                            'recurring'
                          ]">
                          scheduled transaction
                        </a>
                        <ng-container *ngIf="element.reservation_code">
                          for reservation
                          <span class="font-mono inline-flex items-center gap-1">
                            {{ element.reservation_code }}
                            <sbnb-copy-to-clipboard
                              [content]="element.reservation_code"
                              [mini]="true"></sbnb-copy-to-clipboard>
                          </span>
                          .
                        </ng-container>
                      </p>
                      <p *ngIf="element.reservation_code">Transactions are posted when the reservation is created.</p>
                    </div>
                  </sat-popover>
                </td>
              </ng-container>

              <!-- Category Column -->
              <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef>Category</th>
                <td mat-cell *matCellDef="let element" [ngClass]="{ '!border-b-0 !h-10': element.lines.length > 1 }">
                  <ng-container *ngIf="element.lines.length === 1">
                    {{ element.lines[0].category | humanize }}
                  </ng-container>
                </td>
              </ng-container>

              <!-- Description Column -->
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let element" [ngClass]="{ '!border-b-0 !h-10': element.lines.length > 1 }">
                  <ng-container *ngIf="element.lines.length === 1">
                    {{ element.lines[0].description }}
                  </ng-container>
                </td>
              </ng-container>

              <!-- Property Column -->
              <ng-container matColumnDef="property">
                <th mat-header-cell *matHeaderCellDef>Property</th>
                <td mat-cell *matCellDef="let element" [ngClass]="{ '!border-b-0 !h-10': element.lines.length > 1 }">
                  <ng-container *ngIf="element.lines.length === 1">
                    <div>{{ element.lines[0].property.name }}</div>
                    <div
                      *ngIf="element.reservation_code"
                      class="text-mono text-xs inline-flex items-center gap-1 text-night-lighter">
                      {{ element.reservation_code }}
                      <sbnb-copy-to-clipboard
                        [content]="element.reservation_code"
                        [mini]="true"></sbnb-copy-to-clipboard>
                    </div>
                  </ng-container>
                </td>
              </ng-container>

              <!-- Attachment Column -->
              <ng-container matColumnDef="attachment">
                <th mat-header-cell *matHeaderCellDef>Receipt</th>
                <td mat-cell *matCellDef="let element" [ngClass]="{ '!border-b-0 !h-10': element.lines.length > 1 }">
                  <div class="flex items-center justify-center">
                    <sbnb-icon [size]="16" icon="attachment" *ngIf="element.attachments?.length"></sbnb-icon>
                  </div>
                </td>
              </ng-container>

              <!-- Total Column -->
              <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef>Total</th>
                <td mat-cell *matCellDef="let element" [ngClass]="{ '!border-b-0 !h-10': element.lines.length > 1 }">
                  <div class="flex items-center justify-end gap-2">
                    <span
                      class="font-mono text-right"
                      [matTooltip]="
                        element.lines.length === 1 && element.lines[0].quantity > 1
                          ? recurringTotalTooltip(element)
                          : null
                      "
                      [ngClass]="{
                        'underline decoration-dotted': element.lines.length === 1 && element.lines[0].quantity > 1
                      }">
                      {{ element.currency | currencyCode }}{{ element.lines | transactionTotal: 'total' }}
                    </span>
                  </div>
                </td>
              </ng-container>

              <!-- Actions -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" [ngClass]="{ '!border-b-0 !h-10': element.lines.length > 1 }">
                  <div class="flex justify-end pl-4">
                    <ng-container *ngIf="!element.locked && !element.adjustment_uuid; else lockedTransaction">
                      <sbnb-icon
                        *ngIf="!element.computed?.deleting; else deletingTransaction"
                        data-element="delete-transaction"
                        class="clickable text-night hover:text-rose-darker"
                        matTooltip="Delete transaction"
                        matTooltipPosition="before"
                        icon="trash"
                        (click)="$event.stopPropagation(); delete(element)"></sbnb-icon>
                      <ng-template #deletingTransaction>
                        <sbnb-loading-spinner matTooltip="Deleting..."></sbnb-loading-spinner>
                      </ng-template>
                    </ng-container>
                    <ng-template #lockedTransaction>
                      <sbnb-icon
                        data-element="locked-transaction"
                        [matTooltip]="
                          element.adjustment_uuid
                            ? 'This transaction is part of a reservation adjustment and cannot be changed.'
                            : 'This transaction is locked.'
                        "
                        matTooltipPosition="before"
                        icon="padlock"
                        class="text-night-lighter"></sbnb-icon>
                    </ng-template>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="detailDate">
                <td mat-cell *matCellDef="let element"></td>
              </ng-container>

              <ng-container matColumnDef="detailCategory">
                <td mat-cell *matCellDef="let element">
                  <div class="element-detail" [@detailExpand]="element.lines.length > 1 ? 'expanded' : 'collapsed'">
                    <div *ngFor="let line of element.lines" class="mb-3">
                      {{ line.category | humanize }}
                    </div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="detailDescription">
                <td mat-cell *matCellDef="let element">
                  <div class="element-detail" [@detailExpand]="element.lines.length > 1 ? 'expanded' : 'collapsed'">
                    <div *ngFor="let line of element.lines" class="mb-3 ellipsis">
                      {{ line.description }}
                    </div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="detailProperty">
                <td mat-cell *matCellDef="let element" colspan="2">
                  <div class="element-detail" [@detailExpand]="element.lines.length > 1 ? 'expanded' : 'collapsed'">
                    <div *ngFor="let line of element.lines" class="mb-3 ellipsis">
                      {{ line.property.name }}
                    </div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="detailTotal">
                <td mat-cell *matCellDef="let element">
                  <div class="element-detail" [@detailExpand]="element.lines.length > 1 ? 'expanded' : 'collapsed'">
                    <div *ngFor="let line of element.lines" class="flex items-center justify-end">
                      <span class="font-mono text-right text-night-lighter">
                        {{ element.currency | currencyCode }}{{ [line] | transactionTotal }}
                      </span>
                    </div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="detailActions">
                <td mat-cell *matCellDef="let element"></td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                class="hover:bg-smoke-lighter cursor-pointer"
                [routerLink]="row.adjustment_uuid ? ['/operations/statements/adjustments'] : ['.', row.id]"
                [queryParams]="row.adjustment_uuid ? { adjustmentUuid: row.adjustment_uuid } : null"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: detailColumns; when: whenDetailRow"
                class="hover:bg-smoke-lighter cursor-pointer"
                [routerLink]="row.adjustment_uuid ? ['/operations/statements/adjustments'] : ['.', row.id]"
                [queryParams]="row.adjustment_uuid ? { adjustmentUuid: row.adjustment_uuid } : null"></tr>
            </table>

            <div class="mt-4" *ngIf="pagination$ | async as pagination">
              <sbnb-pagination
                data-element="transactions-pagination"
                [pageCount]="pagination.totalPages"
                [currentPage]="pagination.currentPage"
                (pageChanged)="onPageChange($event)"></sbnb-pagination>
            </div>
          </div>

          <div
            *ngIf="!state.loading && !state.error && state.data.length === 0"
            class="w-full flex mt-12 items-center justify-center">
            <sbnb-no-items
              text="No recurring transactions exist yet."
              [buttons]="buttons"
              (button)="onAddTransaction($event)"></sbnb-no-items>
          </div>

          <sbnb-loading-spinner *ngIf="state.loading"></sbnb-loading-spinner>

          <div *ngIf="state.error">{{ state.error }}</div>
        </div>
      </ng-template>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
